import { useCallback, useEffect } from 'react';

import { VIEW_LINK_TYPES, historyTypeInSet } from 'constants/history-view-link-types';
import { useNavigate } from 'react-router-dom';

import { HistoryRow } from 'components/HistoryRow/HistoryRow';

export const AdminCandidateHistoryTab = ({
  candidate,
  company,
  companyChecks,
  referees,
  historyData,
  fetchHistoryData,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (candidate?.id) {
      fetchHistoryData();
    }
  }, [candidate?.id, fetchHistoryData]);

  const handleView = useCallback(
    entry => {
      const tab = entry?.check_type ? 'background_checks' : 'candidate';
      navigate(`/check/${candidate.id}/${tab}`);
    },
    [candidate.id, navigate],
  );

  return (
    <div className="u-padding flex flex-col gap-4">
      {(historyData || []).map(entry => (
        <HistoryRow
          key={entry?.id}
          entry={entry}
          company={company}
          companyChecks={companyChecks}
          candidate={candidate}
          referees={referees}
          onView={entry && historyTypeInSet(VIEW_LINK_TYPES, entry.type) ? handleView : undefined}
        />
      ))}
    </div>
  );
};
